"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lisk_cryptography_1 = require("@liskhq/lisk-cryptography");

var time_1 = require("./time");

exports.createBaseTransaction = function (_ref) {
  var passphrase = _ref.passphrase,
      timeOffset = _ref.timeOffset;

  var _ref2 = passphrase ? lisk_cryptography_1.getAddressAndPublicKeyFromPassphrase(passphrase) : {
    address: undefined,
    publicKey: undefined
  },
      senderId = _ref2.address,
      senderPublicKey = _ref2.publicKey;

  var timestamp = time_1.getTimeWithOffset(timeOffset);
  return {
    amount: '0',
    recipientId: '',
    senderId: senderId,
    senderPublicKey: senderPublicKey,
    timestamp: timestamp
  };
};